import { defineMessages } from '@jutro/locale';

export default defineMessages({
    activityReportsPageHeader: {
        id: 'ml.gateway.views.ActivityReportsPage.Activity Reports',
        defaultMessage: 'Activity Reports'
    },
    backToDashboard: {
        id: 'ml.gateway.views.ActivityReportsPage.Back to Dashboard',
        defaultMessage: 'Back to Dashboard'
    }
});
